module.exports = __webpack_public_path__ + "static/5-74d279d0ce830a1d42a8bed63d146bae.png";